var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestSetup = function SvgTestSetup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.417.5a1.25 1.25 0 0 1 1.244 1.13l.006.12V3H6.5V1.75A1.25 1.25 0 0 1 7.63.506L7.75.5h2.5a1.25 1.25 0 0 1 1.245 1.13l.005.12V3h.834V1.75a1.25 1.25 0 0 1 1.13-1.244l.12-.006h2.5a1.25 1.25 0 0 1 1.244 1.13l.006.12v12.5a1.25 1.25 0 0 1-1.13 1.244l-.12.006H1.917a1.25 1.25 0 0 1-1.244-1.13l-.006-.12V1.75A1.25 1.25 0 0 1 1.797.506L1.917.5zm11.25 10.833h-2.5v2.5h2.5zm-4.167 0h-5v2.5h5zm-6.666 0h-2.5v2.5h2.5zM15.667 8H9.834v1.667h5.833zm-7.5 0H2.334v1.667h5.833zM4 2.167H2.334v4.166h13.333V2.167H14v1.25a1.25 1.25 0 0 1-1.25 1.25h-1.666a1.25 1.25 0 0 1-1.25-1.25v-1.25H8.167v1.25a1.25 1.25 0 0 1-1.25 1.25H5.25A1.25 1.25 0 0 1 4 3.417z",
    clipRule: "evenodd"
  })));
};
export default SvgTestSetup;